export const PUSHCHASE_METHOD = [
  'Contact to Order',
  'Hide Price',
  'Phone To Order',
  'Book a Consult',
  'Password Protected',
];
